<template>
  <li class="has-sub">
    <a href="javascript:;">
      <b class="caret pull-right"></b>
      <i class="fa fa-gear"></i>
      <span>Konfigurasi</span>
    </a>
    <ul class="sub-menu">
      <router-link :to="{path: '/content/section'}" tag="li"><a>Konten</a></router-link>
      <router-link :to="{path: '/content/article'}" tag="li"><a>Artikel</a></router-link>
      <router-link :to="{path: '/content/video'}" tag="li"><a>Video Gratis</a></router-link>
      <!-- <router-link :to="{path: '/content/itembank?mapel=1'}" tag="li"><a>Soal Gratis</a></router-link> -->
      <li class="has-sub">
        <a href="javascript:;">
          <span>Soal Gratis</span>
        </a>
        <ul class="sub-menu">
          <router-link v-for="(menu,index) in items" v-bind:key="index" :to="{path: '/content/itembank?mapel='+menu.id}" tag="li"><a>{{ menu.nama }}</a></router-link>
        </ul>
      </li>
      <router-link :to="{path: '/content/banner'}" tag="li"><a>Banner</a></router-link>
      <router-link :to="{path: '/content/menu'}" tag="li"><a>Menu</a></router-link>
      <router-link :to="{path: '/content/preview'}" tag="li"><a>Pengaturan & Preview</a></router-link>
      <router-link :to="{path: '/config'}" tag="li"><a>Pengaturan Aplikasi </a></router-link>
      <router-link :to="{path: '/ads-setting'}" tag="li"><a>Pengaturan Iklan </a></router-link>

    </ul>
  </li>
</template>

<script>
import itembankService from '@/services/itembank.js'
import bimbelService from '@/services/bimbel.js'
// import SubNavigation from '@/components/itembank/SubNavigation'

export default {
  name: 'content-nav',
  components: {
    // 'subnavigation': SubNavigation
  },
  data: function() {
    return {items: []}
  },
  mounted: function() {
    var context = this
    itembankService.getListMataPelajaran(function(result) {
      if(result.success) {
        localStorage.setItem('mapels', JSON.stringify(result.data))
        result.data.forEach(function(item) {
          context.items.push(item)
        })
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// Navigation.vue?b72b5c58